<template>
  <div
    v-click-outside="closeSwitcher"
    class="flex items-center relative"
    @click="clickedOnSwitcher"
  >
    <CustomButton
      class="flex flex-nowrap items-center justify-center w-10 lg:w-auto text-EXPONDO-primary"
      type="raw"
      @click="toggleSwitcher"
    >
      <span class="max-lg:hidden iconify fa-pro-light--globe text-xl lg:mr-3" />
      <div class="text-left whitespace-nowrap">
        <p class="flex items-center font-normal lg:font-bold text-sm lg:text-base">
          {{ languageName }}
          <span
            class="iconify svg--chevron-right text-sm transform ml-1"
            :class="[!isSwitcherOpen ? 'rotate-90' : '-rotate-90']"
          />
        </p>
        <p class="max-lg:hidden text-xs font-normal">
          {{ $t('language') }}
        </p>
      </div>
    </CustomButton>
    <ul
      v-show="isSwitcherOpen"
      class="list-none absolute top-6 lg:top-12 left-0 bg-EXPONDO-white z-10 w-full rounded-b-lg shadow"
    >
      <li
        v-for="(language, index) in languagesList"
        :key="index"
        class="text-EXPONDO-grey-60 text-sm p-4 cursor-pointer"
        @click="changeLanguage(language.languageCode)"
      >
        {{ language.languageName }}
      </li>
    </ul>
  </div>
</template>
<script lang="ts">


export default defineComponent({
  name: 'TopMenuLanguageSelector',
  emits: ['language-switcher-clicked'],

  setup(_props, { emit }) {

    const { countryLocalization, language } = useLocalization();
    const { changeLanguage } = useLanguageSelector();

    const languagesList = computed(() => {

      const languages = countryLocalization.value.getLanguageAndCountries();

      return languages
        .filter(item => !item.includes(language.value))
        .map(item => ({
          languageCode: item,
          languageName: item.split('-')[0].toUpperCase(),
        }));
    
    });
    const languageName = computed(() => language.value.toUpperCase());
    const isSwitcherOpen = ref(false);

    const toggleSwitcher = () => {

      isSwitcherOpen.value = !isSwitcherOpen.value;
    
    };

    const closeSwitcher = () => {

      if (isSwitcherOpen.value) {

        isSwitcherOpen.value = false;
      
      }
    
    };

    const clickedOnSwitcher = () => {

      emit('language-switcher-clicked');
    
    };

    return {
      countryLocalization,
      changeLanguage,
      languageName,
      languagesList,
      isSwitcherOpen,
      toggleSwitcher,
      closeSwitcher,
      clickedOnSwitcher,
    };
  
  },
});


</script>
